import Config from "@/config/config.js";
import AsyncUtils from "@/utils/asyncUtils.js";
import Services, { handleError } from "./index.service";
import { getSession } from "@/hooks/useSession.js";
import { STATE, CurrentStudyState } from "@state";
import AuthService from "@services/auth.service.js";
import { sha256 } from "@crypto";

const { OshimedBackend, OshimedAPI } = Services;

const registerStudy = async (body, xApiKey) => {
  const session = getSession();
  try {
    const response = await OshimedAPI.post("/study", body, {
      headers: {
        "x-api-key": xApiKey,
        Authorization: `Bearer ${session.apiToken}`,
      },
    });

    if (!response.data) {
      return {
        success: false,
        message: "Error registering study",
        fromError: response,
        errorCode: "register-study-error",
        errorKey: 651925,
      };
    }

    return response.data;
  } catch (error) {
    console.log("=== error === study.service.js === key: 84068 ===");
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 694285);
  }
};

/**
 * Récupère les etudes pour un cro
 * @param {string}  userId - L'ID de l utilisateur à récupérer
 * @returns {Promise<object>} Les etude lié a l'utilisateur ou un objet d'erreur
 */

const getStudiesByUserId = async (userId) => {
  console.log(
    "=== Service: getstudiesByUserId called with ID === study.service.js === key: 834522 ==="
  );
  console.dir(userId, { depth: null, colors: true });
  console.log("=================================");
  try {
    const url = `${Config.BACKEND_URL}/study/user-id/${userId}`;
    console.log("Request URL:", url);
    const response = await OshimedBackend.get(url);

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getStudiesByUserId:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 834521);
  }
};

const getStudiesByEntityId = async (entityId) => {
  console.log(
    "=== Service: getstudiesByEntityId called with ID === study.service.js === key: 834522 ==="
  );
  console.dir(entityId, { depth: null, colors: true });
  console.log("=================================");
  try {
    const url = `${Config.BACKEND_URL}/study/entity-id/${entityId}`;
    console.log("Request URL:", url);
    const response = await OshimedBackend.get(url);

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getStudiesByEntityId:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 834521);
  }
};

/**
 * Récupère les metrics pour un etude specifiqué pour un CRO
 * @param {string}  studyId - L'ID de l'etude à récupérer
 * @returns {Promise<object>} Les metrics lié a l etude  ou un objet d'erreur
 */
const getStudyMetricsCRO = async (studyId) => {
  console.log(
    "=== Service: getStudyMetricsCRO called with ID === study.service.js === key: 834592 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");
  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/metrics-cro`;
    console.log("Request URL:", url);
    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 834723 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getStudyMetricsCRO:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 831521);
  }
};

/**
 *
 * @param {string}  studyId -
 * @returns {Promise<object>}
 */

const getStudyPatientsCRO = async (studyId) => {
  console.log(
    "=== Service: getStudyPatientsCRO called with ID === study.service.js === key: 834992 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `/study/${studyId}/latest-enrolments`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);

    console.log(
      "=== Service: API response === study.service.js === key: 550624 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!Array.isArray(response.data)) {
      console.warn("API returned unexpected response format:", response.data);
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getStudyPatientsCRO:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 831521);
  }
};

const getStudyGeneralSettingsCRO = async (studyId) => {
  console.log(
    "=== Service: getStudyGeneralSettingsCRO called with ID === study.service.js === key: 835401 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/general-settings`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 835502 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getStudyGeneralSettingsCRO:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 835603);
  }
};

const getMasterIcfSettingsCRO = async (studyId) => {
  console.log(
    "=== Service: getSMasterIcfSettingsCRO called with ID === study.service.js === key: 835991 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/master-icf-settings`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 835572 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.log("=== error === study.service.js === key: 205904 ===");
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 835603);
  }
};

const getSiteSettingsCRO = async (studyId) => {
  console.log(
    "=== Service: getSiteSettingsCRO called with ID === study.service.js === key: 657283 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/site-settings`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 784392 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getSiteSettingsCRO:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 834629);
  }
};

const getRoleManagementCRO = async (studyId) => {
  console.log(
    "=== Service: getRoleManagementCRO called with ID === study.service.js === key: 392847 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/role-management`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 485729 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getRoleManagementCRO:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 573829);
  }
};

/**
 * Récupère les etudes pour un cro
 * @param {string}  userId - L'ID de l utilisateur à récupérer
 * @returns {Promise<object>} Les etude lié a l'utilisateur ou un objet d'erreur
 */

const getInvestigatorStudiesByUserId = async (userId) => {
  console.log(
    "=== Service: getInvestigatorStudiesByUserId  called with ID === study.service.js === key: 8341122 ==="
  );
  console.dir(userId, { depth: null, colors: true });
  console.log("=================================");
  try {
    const url = `${Config.BACKEND_URL}/study/${userId}/investigator-studies`;
    console.log("Request URL:", url);
    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 8345053 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getInvestigatorStudiesByUserId:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 834521);
  }
};

const getInvestigatorStudyOverview = async ({ studyId, userId }) => {
  console.log(
    "=== Service: getInvestigatorStudyOverview called with ID === study.service.js === key: 835901 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/investigator-overview`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 825502 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getInvestigatorStudyOverview:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 935603);
  }
};

const getInvestigatorPatientsManagement = async (studyId) => {
  console.log(
    "=== Service: getInvestigatorPatientsManagement called with ID === study.service.js === key: 135901 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/investigator-patients`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 125502 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getInvestigatorPatientsManagement:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 9435603);
  }
};

// ------------------------------
// Bulk Site (platform endpoint)
// ------------------------------
/**
 * POST /site/bulk – envoie un tableau de sites au backend plateforme.
 * Utilise OshimedBackend (plateforme) et inclut automatiquement le token plateforme via l'intercepteur.
 * @param {Array<object>} sites – tableau de sites (STATE[CurrentStudyState.SITES])
 */
const postBulkSitesPlatform = async (sites) => {
  try {
    const response = await OshimedBackend.post("/site/bulk", sites);
    return response.data;
  } catch (error) {
    console.log(
      "=== error === study.service.js (postBulkSitesPlatform) === key: 557218 ==="
    );
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 557218);
  }
};

// ------------------------------
// Study Site
// ------------------------------
/**
 * PATCH /study/site – ajoute ou met à jour un site pour une étude.
 * @param {object} payload – données du site (voir spécification backend)
 * @param {string} xApiKey – clé API temporaire obligatoire
 */
const patchStudySite = async (payload, xApiKey) => {
  const session = getSession();
  try {
    const response = await OshimedAPI.patch("/study/site", payload, {
      headers: {
        Authorization: `Bearer ${session?.apiToken}`,
        "x-api-key": xApiKey,
      },
    });
    return response.data;
  } catch (error) {
    console.log(
      "=== error === study.service.js (patchStudySite) === key: 228511 ==="
    );
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 228511);
  }
};

// ------------------------------
// Study Protocol Version
// ------------------------------
/**
 * Upload or update a study protocol version (multipart/form-data).
 * Correspond à la route PATCH /study/protocol-version
 * @param {FormData} formData – données du protocole à envoyer
 * @returns {Promise<object>} résultat de l'appel API ou erreur normalisée
 */
const patchStudyProtocolVersion = async (formData, xApiKey) => {
  const session = getSession();
  try {
    const response = await OshimedAPI.patch(
      "/study/protocol-version",
      formData,
      {
        headers: {
          Authorization: `Bearer ${session?.apiToken}`,
          ...(xApiKey ? { "x-api-key": xApiKey } : {}),
          "Content-Type": "multipart/form-data",
          // 'Content-Type' est défini automatiquement par Axios pour FormData
        },
      }
    );

    if (!response.data) {
      return {
        success: false,
        message: "Empty response while patching protocol version",
        fromError: response,
        errorCode: "patch-protocol-version-empty",
        errorKey: 615942,
      };
    }
    return response.data;
  } catch (error) {
    console.log(
      "=== error === study.service.js (patchStudyProtocolVersion) === key: 615942 ==="
    );
    console.dir(error, { depth: null, colors: true });
    console.log("=================================");
    return handleError(error, 615942);
  }
};

const updateBackendProtocolVersion = async (data) => {

  console.log('=== data === study.service.js === key: 265155 ===');
  console.dir(data, { depth: null, colors: true })
  console.log('=================================');
  
  //send to OshimedBackend route POST "/site/icf"
  const session = getSession(); 
  try {
    const response = await OshimedBackend.post("/site/icf", data);
    return response.data;
  } catch (error) {
    console.log('=== error === study.service.js === key: 558704 ===');
    console.dir(error, { depth: null, colors: true })
    console.log('=================================');
    return handleError(error, 615942);
  }
}

const studyExist = async (studyId) => {
  console.log(
    "=== Service: studyExist called with ID === study.service.js === key: 175901 ==="
  );
  console.dir(studyId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/${studyId}/exists`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === study.service.js === key: 122412 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in studyExist:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 948403);
  }
};
//TODO = CETTE FUNCTION N EST PAS LIE AU WEBHOKK
/**
 * Sends an array of milestones for a specific study to the backend.
 * @param {string} studyId - The UUID identifier of the study.
 * @param {Array<object>} milestones - An array of milestone objects from the frontend.
 * @returns {Promise<object>} Result of the sending operation or an error object.
 */
const addMilestones = async (studyId, milestones) => {
  console.log(
    "=== { studyId, milestones } === study.service.js === key: 840918 ==="
  );
  console.dir({ studyId, milestones }, { depth: null, colors: true });
  console.log("=================================");

  const returningMilestones = [];

  /** ------------------ cmt 519144 ------------------
    if (!response.data.milestones) {
      console.log("=== response === study.service.js === key: 816888 ===");
      console.dir(response, { depth: null, colors: true });
      console.log("=================================");
      return null;
    }
    *-------------------------------------------------*/
  // After successful platform save, send each milestone to OshimedAPI per site with a fresh x-api-key
  try {
    const session = getSession();
    if (!session?.apiToken || !session?.user?.email) {
      console.log("=== session === study.service.js === key: 730141 ===");
      console.dir(session, { depth: null, colors: true });
      console.log("=================================");
    } else {
      // for (const site of sites) {

      //const protocolId = site?.siteIcfId||site?.site_icf_id;

      

      for (const ms of milestones) {
        console.log("=== ms === study.service.js === key: 396076 ===");
        console.dir(ms, { depth: null, colors: true });
        console.log("=================================");

        const res = await insertMilestoneToBlockchain(studyId, ms);
        console.log("=== res === study.service.js === key: 633749 ===");
        console.dir(res, { depth: null, colors: true });
        console.log("=================================");

        if (res?.success === true) {
          const url = `${Config.BACKEND_URL}/study/${studyId}/milestones`;
          console.log("Request URL for milestones:", url);
          ms.id = res.milestoneId;
          const response = await OshimedBackend.post(url, {
            milestones: [ms],
          });
          returningMilestones.push(response.data);
        }
      }
      // }
    }
  } catch (err) {
    console.log("=== err === study.service.js === key: 490699 ===");
    console.dir(err, { depth: null, colors: true });
    console.log("=================================");
  }

return returningMilestones;
};

const insertMilestoneToBlockchain = async (studyId, milestone) => {
  const session = getSession();
  const protocolId = studyId;
  const studyIdFromSite = studyId;
  const ms = milestone;

  console.log("=== ms === study.service.js === key: 413158 ===");
  console.dir(ms, { depth: null, colors: true });
  console.log("=================================");

  try {
    const emailClear = session.user.email;
    const hashedEmail = await sha256(emailClear);
    const tmpKeyRes = await AuthService.getTmpApiKey(hashedEmail);
    if (tmpKeyRes?.success === false || !tmpKeyRes) {
      console.log("=== tmpKeyRes === study.service.js === key: 977803 ===");
      console.dir(tmpKeyRes, { depth: null, colors: true });
      console.log("=================================");
      //continue;
    }

    const payload = {
      title: ms?.name || ms.title || "unknown",
      shortDescription: ms?.description || ms?.shortDescription || "unknown",
      description: ms?.description || ms?.shortDescription || "unknown",
      protocolId: protocolId || "unknown",
      studyId: studyIdFromSite || "unknown",
      mandatory: ms?.mandatory === true,
      status: "validated",
    };

    console.log("=== payload === study.service.js === key: 105598 ===");
    console.dir(payload, { depth: null, colors: true });
    console.log("=================================");

    const apiResp = await OshimedAPI.patch("/study/milestone", payload, {
      headers: {
        Authorization: `Bearer ${session.apiToken}`,
        "x-api-key": tmpKeyRes,
      },
    });
    console.log("=== apiResp === study.service.js === key: 560031 ===");
    console.dir(apiResp, { depth: null, colors: true });
    console.log("=================================");
    return (
      apiResp?.data || {
        success: false,
        message: "Error inserting milestone to blockchain",
        fromError: apiResp,
        errorCode: "insert-milestone-to-blockchain-error",
        errorKey: 250893,
      }
    );
  } catch (err) {
    console.log("=== err === study.service.js === key: 167746 ===");
    console.dir(err, { depth: null, colors: true });
    console.log("=================================");
    return {
      success: false,
      message: err.message,
      fromError: err,
      errorCode: "insert-milestone-to-blockchain-error",
      errorKey: 999395,
    };
  }
};

/**
 * PUT /study/:studyId/milestone/:milestone_id – Met à jour une milestone spécifique d'une étude.
 * @param {string} studyId – L’UUID de l’étude.
 * @param {string} milestone_id – L’UUID de la milestone.
 * @param {object} updates – Champs à mettre à jour: name, description, mandatory.
 * @returns {Promise<object|null>} Données mises à jour ou erreur normalisée.
 */
const updateMilestoneById = async (studyId, milestone_id, updates) => {
  console.log(
    "=== {studyId, milestone_id, updates} === study.service.js === key: 125406 ==="
  );
  console.dir(
    { studyId, milestone_id, updates },
    { depth: null, colors: true }
  );
  console.log("=================================");

  try {
    const response = await OshimedBackend.put(
      `/study/${studyId}/milestone/${milestone_id}`,
      updates
    );

    if (!response?.data) {
      console.warn("Empty response from updateMilestoneById");
      return null;
    }

    console.log("=== API response === study.service.js === key: 792104 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    return response.data;
  } catch (error) {
    console.error("Service error in updateMilestoneById:", error);
    return handleError(error, 792105);
  }
};

/**
 * deactivate /study/:studyId/milestone/:milestone_id – deactivate une milestone spécifique d'une étude.
 * @param {string} studyId – L’UUID de l’étude.
 * @param {string} milestone_id – L’UUID de la milestone.
 * @returns {Promise<object|null>} Résultat du backend ou erreur normalisée.
 */
const deactivateMilestoneById = async (studyId, milestone_id) => {
  console.log(
    "=== Service: deactivateMilestoneById called === study.service.js === key: 469822 ==="
  );
  console.log("→ studyId:", studyId);
  console.log("→ milestone_id:", milestone_id);
  console.log("=================================");

  try {
    const url = `/study/${studyId}/milestone/${milestone_id}`;
    const response = await OshimedBackend.patch(url);

    if (!response?.data) {
      console.warn("Empty response from deactivateMilestoneById");
      return null;
    }

    console.log("=== API response === study.service.js === key: 469823 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    return response.data;
  } catch (error) {
    console.error("Service error in deactivateMilestoneById:", error);
    return handleError(error, 469824);
  }
};

//TODO = CETTE FUNCTION N EST PAS LIE AU WEBHOKK

/**
 * Sends a request to add a single milestone to a specific study.
 * @param {string} studyId - UUID of the study
 * @param {object} milestone - Object containing name, description, mandatory, master_icf_id
 * @returns {Promise<object>} API response
 */
/** ------------------ cmt 239228 ------------------
const addMilestoneToStudy = async (studyId, milestone) => {
  console.log("=== Service: API call === study.service.js === key: 835114 ===")
  console.log("addMilestoneToStudy →", { studyId, milestone })

  try {
    const session = getSession()

    const response = await OshimedBackend.post(`/study/${studyId}/milestone`, milestone, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session?.apiToken}`,
      },
    })

    console.log("=== Service: API response === study.service.js === key: 835114 ===")
    console.log(response.data)

    return response.data
  } catch (error) {
    console.error("=== Service: API error === study.service.js === key: 835114 ===")
    return handleError(error, 835114)
  }
}
*-------------------------------------------------*/

/**
 * Récupère les données binaires d'un document protocole.
 * @param {string} studyId - L'ID de l'étude associée au protocole.
 * @param {string} protocolId - L'ID du protocole à récupérer.
 * @param {string} xApiKey - La clé API temporaire.
 * @returns {Promise<object>} Les données du document (type Blob) ou un objet d'erreur.
 */
const getProtocolDocumentData = async (studyId, protocolId, xApiKey) => {
  console.log("=== Service: getProtocolDocumentData appelé avec ID ===");
  console.dir({ studyId, protocolId }, { depth: null, colors: true });
  console.log("=================================");

  try {
    const session = getSession();

    const response = await OshimedAPI.get("/study/protocol-document-by-id", {
      params: { studyId, protocolId },
      headers: {
        "x-api-key": xApiKey,
        Authorization: `Bearer ${session?.apiToken}`,
      },
      responseType: "arraybuffer",
    });

    if (!response.data || response.data.byteLength === 0) {
      return {
        success: false,
        message: "Réponse vide pour le document protocole",
        errorCode: "protocol-document-empty-response",
        errorKey: 900001,
      };
    }

    const pdfBlob = new Blob([response.data], { type: "application/pdf" });

    return { success: true, data: pdfBlob };
  } catch (error) {
    console.error("Erreur de service dans getProtocolDocumentData:", error);

    if (error.response?.data instanceof ArrayBuffer) {
      const decoded = new TextDecoder("utf-8").decode(error.response.data);
      console.error("Erreur décodée:", decoded);
    } else {
      console.error(
        "Détails de l'erreur:",
        error.response?.data || error.message
      );
    }

    return handleError(error, 900002);
  }
};

/**
 * GET /consent-details/:patientId – récupère les infos de consentement d’un patient.
 * Utilise OshimedBackend et retourne directement les données sans wrapper `success`.
 * @param {string} patientId – L’UUID du patient.
 * @returns {Promise<object|null>} Les détails du consentement ou erreur normalisée.
 */
const getPatientConsentDetails = async (patientId) => {
  console.log(
    "=== Service: getPatientConsentDetails called === study.service.js === key: 615041 ==="
  );
  console.dir(patientId, { depth: null, colors: true });
  console.log("=================================");

  try {
    const url = `${Config.BACKEND_URL}/study/patient-consent/${patientId}`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log("=== API response === study.service.js === key: 615042 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response for patient consent details");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getPatientConsentDetails:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 615043);
  }
};

/**
 * GET /patient-consent-by-participant/:participantId – récupère les infos de consentement via participantId.
 * @param {string} participantId – L’UUID du participant.
 * @returns {Promise<object|null>} Les détails du consentement ou erreur normalisée.
 */
const getPatientConsentDetailsByParticipantId = async (participantId) => {
  console.log(
    "=== Service: getPatientConsentDetailsByParticipantId called === study.service.js ==="
  );
  console.dir(participantId, { depth: null, colors: true });

  try {
    const url = `${Config.BACKEND_URL}/study/patient-consent-by-participant/${participantId}`;
    console.log("Request URL:", url);

    const response = await OshimedBackend.get(url);
    console.log("=== API response === study.service.js ===");
    console.dir(response.data, { depth: null });

    if (!response.data) {
      console.warn("API returned empty response for participant consent details");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Service error in getPatientConsentDetailsByParticipantId:", error);
    return handleError(error, 615044);
  }
};

/**
 * Update general settings of a study.
 * @param {object} params
 * @param {string} params.studyId
 * @param {string} params.title
 * @param {string} params.estimated_duration
 * @param {number} params.threshold_of_consenting_participants
 * @returns {Promise<object>}
 */
const updateStudyGeneralSettings = async ({
  studyId,
  title,
  estimated_duration,
  threshold_of_consenting_participants,
}) => {
  try {
    console.log(" [updateStudyGeneralSettings] Sending update request:", {
      studyId,
      title,
      estimated_duration,
      threshold_of_consenting_participants,
    });

    const response = await OshimedBackend.put(
      `/study/${studyId}/general-settings`,
      {
        title,
        estimated_duration,
        threshold_of_consenting_participants,
      }
    );

    console.log(
      "[updateStudyGeneralSettings] Update successful:",
      response.data
    );
    return response.data;
  } catch (error) {
    console.error(" [updateStudyGeneralSettings] Error during update:", error);
    return handleError(error, "updateStudyGeneralSettings");
  }
};

//TODO: Cette fonction ajoute un master icf seulement en backend

/**
 * POST /study/:studyId/master-icf – ajoute un nouveau Master ICF à une étude existante.
 * Utilise OshimedBackend et retourne directement la réponse sans wrapper `success`.
 * @param {string} studyId – L’UUID de l’étude.
 * @param {string} name – Le nom du Master ICF.
 * @returns {Promise<object|null>} Données du Master ICF ou erreur normalisée.
 */
const addMasterIcfToStudy = async (studyId, name) => {
  console.log(
    "=== Service: addMasterIcfToStudy called === study.service.js === key: 762110 ==="
  );
  console.log("→ studyId:", studyId);
  console.log("→ name:", name);
  console.log("=================================");

  try {
    const response = await OshimedBackend.post(
      `/study/${studyId}/add-master-icf`,
      {
        studyId,
        masterICFName: name,
      }
    );

    if (!response?.data) {
      console.warn("Empty response from addMasterIcfToStudy");
      return null;
    }

    console.log("=== API response === study.service.js === key: 762111 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    return response.data?.data;
  } catch (error) {
    console.error(" Service error in addMasterIcfToStudy:", error);
    return handleError(error, 762112);
  }
};

//TODO: CETTE FONCTION SUPPRIME  LE MASTER ICF UNIQUEMENT EN DB

/**
 * DELETE /study/:studyId/master-icf/:masterIcfId
 * Supprime un Master ICF spécifique d'une étude.
 * @param {string} studyId – L’UUID de l’étude.
 * @param {string} masterIcfId – L’UUID du Master ICF.
 * @returns {Promise<object>} – Résultat du backend.
 */
const deactivateMasterIcfFromStudy = async (studyId, masterIcfId) => {
  try {
    const url = `/study/${studyId}/master-icf/${masterIcfId}`;
    const response = await OshimedBackend.patch(url);

    return response.data || null;
  } catch (error) {
    console.error(" Service error in deactivateMasterIcfFromStudy:", error);
    return handleError(error, 531100);
  }
};

//TODO: CETTE FONCTION CHANGE LE STATUS  UNIQUEMENT EN DB

/**
 * POST /study/:studyId/close – Clôture une étude existante.
 * Utilise OshimedBackend et retourne directement la réponse sans wrapper `success`.
 * @param {string} studyId – L’UUID de l’étude à clôturer.
 * @returns {Promise<object|null>} Objet d’étude mis à jour ou erreur normalisée.
 */
const closeStudyById = async (studyId) => {
  console.log(
    "=== Service: closeStudyById called === study.service.js === key: 173209 ==="
  );
  console.log("→ studyId:", studyId);
  console.log("=================================");

  try {
    const response = await OshimedBackend.put(`/study/${studyId}/close`);

    if (!response?.data) {
      console.warn("Empty response from closeStudyById");
      return null;
    }

    console.log("=== API response === study.service.js === key: 173210 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    return response.data;
  } catch (error) {
    console.error("Service error in closeStudyById:", error);
    return handleError(error, 173211);
  }
};

/**
 * GET /master-icf/mappings – récupère les mappings pour un Master ICF.
 * Utilise OshimedBackend et retourne les données ou une erreur normalisée.
 * @param {string} masterIcfId – L’UUID du Master ICF.
 * @returns {Promise<object|null>} Données de mapping ou erreur.
 */
const getMasterIcfMappings = async (masterIcfId) => {
  console.log(
    "=== Service: getMasterIcfMappings called === study.service.js === key: 716241 ==="
  );
  console.log("→ masterIcfId:", masterIcfId);
  console.log("=================================");

  try {
    const response = await OshimedBackend.get(`/study/master-icf/mappings`, {
      params: { masterIcfId },
    });

    console.log("=== API response === study.service.js === key: 716242 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    return response.data;
  } catch (error) {
    console.error("Service error in getMasterIcfMappings:", error);
    return handleError(error, 716243);
  }
};

/**
 * POST /study/master-icf/:masterIcfId/mappings – remplace les mappings d’un Master ICF.
 * Utilise OshimedBackend et retourne les données ou une erreur normalisée.
 * @param {string} masterIcfId – L’UUID du Master ICF.
 * @param {Array<{id: string, masterIcfId: string, milestoneId: string, studyId: string}>} items – Les mappings à insérer.
 * @returns {Promise<object|null>} Résultat des mappings ou erreur.
 */
const replaceMasterIcfMappings = async (masterIcfId, items) => {
  console.log(
    "=== Service: replaceMasterIcfMappings called === study.service.js === key: 716244 ==="
  );
  console.log("→ masterIcfId:", masterIcfId);
  console.log("→ mappings items:", items);
  console.log("=================================");

  try {
    const response = await OshimedBackend.post(
      `/study/master-icf/${masterIcfId}/mappings`,
      items
    );

    console.log("=== API response === study.service.js === key: 716245 ===");
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    return response.data;
  } catch (error) {
    console.error("Service error in replaceMasterIcfMappings:", error);
    return handleError(error, 716246);
  }
};

const StudyService = {
  getStudiesByUserId,
  getStudyMetricsCRO,
  getStudyPatientsCRO,
  getStudyGeneralSettingsCRO,
  getMasterIcfSettingsCRO,
  getSiteSettingsCRO,
  getRoleManagementCRO,
  getInvestigatorStudiesByUserId,
  getInvestigatorStudyOverview,
  getInvestigatorPatientsManagement,
  registerStudy,
  patchStudyProtocolVersion,
  patchStudySite,
  postBulkSitesPlatform,
  studyExist,
  addMilestones,
  getProtocolDocumentData,
  getStudiesByEntityId,
  getPatientConsentDetails,
  getPatientConsentDetailsByParticipantId,
  updateStudyGeneralSettings,
  addMasterIcfToStudy,
  deactivateMasterIcfFromStudy,
  closeStudyById,
  //addMilestoneToStudy,
  updateMilestoneById,
  deactivateMilestoneById,
  getMasterIcfMappings,
  replaceMasterIcfMappings,
  updateBackendProtocolVersion,
};

export default StudyService;
